import { Stack } from '@mui/material'
import { useEffect } from 'react'

interface ConfigLayoutProps {
  title: string
  header?: React.ReactNode
  footer?: React.ReactNode
  rightLayout?: React.ReactNode
  children?: React.ReactNode
  fullWidth?: boolean
}

const SetUpLayout = ({
  title = '',
  children,
  footer,
  header,
  rightLayout,
  fullWidth = false,
}: ConfigLayoutProps) => {
  useEffect(() => {
    document.title = `${title} | Cisgenics Admin`
  }, [title])

  return (
    <Stack
      minHeight="100vh"
      bgcolor="background.default"
      direction="row"
      flexGrow="1"
    >
      {rightLayout ? (
        <Stack sx={{ width: '95%', flexGrow: 1, overflow: 'hidden' }}>
          {header}
          <Stack
            sx={{ padding: fullWidth ? '0px' : '25px 32px', flexGrow: 1 }}
            className="setuplayout-children"
          >
            {children}
          </Stack>
          <Stack sx={{ display: 'flex', bottom: '0', justifyContent: 'end' }}>
            {footer}
          </Stack>
        </Stack>
      ) : (
        <Stack sx={{ width: '100%', flexGrow: 1 }}>
          {header}
          <Stack
            sx={{ padding: fullWidth ? '0px' : '25px 32px', flexGrow: 1 }}
            className="setuplayout-children"
          >
            {children}
          </Stack>
          <Stack sx={{ display: 'flex', bottom: '0', justifyContent: 'end' }}>
            {footer}
          </Stack>
        </Stack>
      )}
      <Stack
        sx={{
          display: 'flex',
          bottom: '0',
          justifyContent: 'right',
          flexGrow: '1',
        }}
      >
        {rightLayout}
      </Stack>
    </Stack>
  )
}

export default SetUpLayout
